/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendFinancingSourceDto } from '../../models/backend-financing-source-dto';

export interface ProjectsFinancingSourcesList$Params {}

export function projectsFinancingSourcesList(
  http: HttpClient,
  rootUrl: string,
  params?: ProjectsFinancingSourcesList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendFinancingSourceDto>>> {
  const rb = new RequestBuilder(rootUrl, projectsFinancingSourcesList.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendFinancingSourceDto>>;
    }),
  );
}

projectsFinancingSourcesList.PATH = '/api/projects/financing-sources/';
